import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './components/auth/auth.guard';
import { PageNotFoundComponent } from './pages/not-found.component';
import { NotAuthorizedComponent } from './pages/not-authorized-compoment';
import { AuthRoleGuard } from './components/auth/auth-role.guard';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { SliderModule } from 'primeng/slider';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SpinnerModule } from 'primeng/spinner';
import { SplitButtonModule } from 'primeng/splitbutton';

import { TooltipModule } from 'primeng/tooltip';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { AccordionModule } from 'primeng/accordion';
import { PaginatorModule } from 'primeng/paginator';
import { NbDatepickerModule, NbToastrModule, NbActionsModule, NbAlertModule, NbStepperModule, NbAccordionModule, NbListModule, NbCardModule, NbSpinnerModule , NbLayoutModule} from '@nebular/theme';

import { GroupByPipe } from '../../CustomPipes/GroupBy';
import { ReportBuilderExecutorComponent } from './components/report-builder-executor/report-builder-executor.component';

import { ListboxModule } from 'primeng/listbox';
import { RbLetterAvatarModule } from 'rb-letter-avatar';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { PanelModule } from 'primeng/panel';
import { LazyLoadedTableComponent } from './components/lazy-loaded-table/lazy-loaded-table.component';
import { ToggleButtonModule } from 'primeng/togglebutton';
//import { PopoverModule } from 'ngx-popover';
import { AngularSplitModule } from 'angular-split';
import { KeyFilterModule } from 'primeng/keyfilter';
import { FileUploadModule } from 'primeng/fileupload';
import { SignalRService } from '../../services/signalr/signal-rservice.service';
import { GalleriaModule } from 'primeng/galleria'; import { ConfirmDialogModule } from 'primeng/confirmdialog'; // Mandatory for angular-modal-gallery 3.x.x or greater (`npm i --save hammerjs`)
import 'mousetrap'; // Mandatory for angular-modal-gallery 3.x.x or greater (`npm i --save mousetrap`)
//import { ModalGalleryModule } from '@ks89/angular-modal-gallery';
import { MfFormFieldsComponent } from '@framework/components/mf-form-fields/mf-form-fields.component';
import { ListPageComponent } from '@framework/components/mf-list-page/mf-list-page.component';
import { StorageServiceModule } from 'ngx-webstorage-service';
import { MfFormControlComponent } from '@framework/components/mf-form-control/mf-form-control.component';
import { CheckboxModule } from 'primeng/checkbox';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MfColumnSelectorComponent } from '@framework/components/mf-column-selector/mf-column-selector.component';
import { MfBladeFormsComponent } from '../../framework/components/mf-blade-forms/mf-blade-forms.component';
import { MfFiltersComponent } from '../../framework/components/mf-filters/mf-filters.component';
import { MfGeneratedFormComponent } from '../../framework/components/mf-generated-form/mf-generated-form.component';
import { FileSaverModule } from 'ngx-filesaver';
import { DynamicDialogModule, DialogService } from 'primeng/dynamicdialog';
import { ActionDialogComponent } from './components/action-dialog/action-dialog.component';
import { ComboBoxModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { SplitterModule } from '@progress/kendo-angular-layout';
import { MfTableV2Component } from '../../framework/components/mf-table-v2/mf-table-v2.component';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';

import { UploadsModule } from '@progress/kendo-angular-upload';
import { DateRangeFilterCellComponent } from '../../framework/components/mf-table-v2/filter-cells/date-range-filter-cell.component';
import { DropDownListFilterComponent } from '../../framework/components/mf-table-v2/filter-cells/dropdownlist-filter.componennt';
import '../../framework/tools';
import { MfcustomUploadComponent } from '../../framework/components/mf-form-control/mfcustom-upload/mfcustom-upload.component';



import { IntRangeFilterComponent } from '../../framework/components/mf-table-v2/filter-cells/int-range-filter.componennt';
import { MfPanelFormsComponent } from '../../framework/components/mf-panel-forms/mf-panel-forms.component';
import { MfPanelComponent } from '../../framework/components/mf-panel/mf-panel.component';
import '../../framework/tools';
import { MfBreadcrumbsComponent } from '../../framework/components/mf-breadcrumbs/mf-breadcrumbs.component';

import { WindowModule } from '@progress/kendo-angular-dialog';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { MfControlPopupComponent } from '../../framework/components/mf-control-popup/mf-control-popup.component';


import { NgxMaskModule } from 'ngx-mask'
import { MfControlUnsavedPopupComponent } from '../../framework/components/mf-control-unsaved-popup/mf-control-unsaved-popup.component';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { FormControlCell } from '../../framework/components/mf-table-v2/filter-cells/form-control-cell';
import { MfPopupPanelComponent } from '../../framework/components/mf-popup-panel/mf-popup-panel.component';
import { MFCustomDatePickerComponent } from '../../framework/components/mf-form-control/mfcustom-date-picker/mfcustom-date-picker.component';
import { MFCustomTimePickerComponent } from '../../framework/components/mf-form-control/mfcustom-time-picker/mfcustom-time-picker.component';
import { MfCustomSignatureComponent } from '../../framework/components/mf-form-control/mfcustom-signature/mfcustom-signature.component';

import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { TreeViewModule } from '@progress/kendo-angular-treeview';

import { CovalentLayoutModule } from '@covalent/core/layout';
import { CovalentCommonModule } from '@covalent/core/common';
import { CovalentMediaModule } from '@covalent/core/media';
import { CovalentExpansionPanelModule } from '@covalent/core/expansion-panel';
import { CovalentStepsModule } from '@covalent/core/steps';
import { CovalentDialogsModule } from '@covalent/core/dialogs';
import { CovalentSearchModule } from '@covalent/core/search';
import { CovalentPagingModule } from '@covalent/core/paging';
import { CovalentNotificationsModule } from '@covalent/core/notifications';
import { CovalentMenuModule } from '@covalent/core/menu';
import { CovalentDataTableModule } from '@covalent/core/data-table';
import { CovalentMessageModule } from '@covalent/core/message';
import { CovalentBreadcrumbsModule } from '@covalent/core/breadcrumbs';
import { CovalentLoadingModule } from '@covalent/core/loading';
import { CovalentTabSelectModule } from '@covalent/core/tab-select';
import { PasswordExpiredComponent } from './components/password-expired/password-expired.component';
import { MFCustomDatetimePopupComponent } from '../../framework/components/mf-form-control/mfcustom-datetime-popup/mfcustom-datetime-popup.component';
import { MfBladeComponent } from '../../framework/components/mf-blade/mf-blade.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';
import { MetricListComponent } from './components/metric-list/metric-list.component';
import { MetricComponent } from './components/metric/metric.component';
import { IsEllipsisActiveDirective } from '../../framework/directives/is-ellipsis-active';
import { DonutWithCenteredTextComponent } from './components/donut-with-centered-text/donut-with-centered-text.component';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { TreeListModule } from '@progress/kendo-angular-treelist';
import { AngularResizedEventModule } from 'angular-resize-event';
import { AutoPanelNavComponent } from '../../framework/components/auto-panel-nav/auto-panel-nav.component';
import { MfMultiInstanceGridComponent } from '../../framework/components/mf-form-control/mf-multi-instance-grid/mf-multi-instance-grid.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { GridColsDirective } from '../../framework/directives/gridCols';
import { ArraySortPipe } from '../../CustomPipes/sort';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { MfMasterDetailGridComponent } from '../../framework/components/mf-form-control/mf-master-detail-grid/mf-master-detail-grid.component';
import { FileUploaderComponent } from '../../framework/components/mf-form-control/file-uploader/file-uploader.component';
import { MfChromeSupportComponent } from '../../framework/components/mf-chrome-support/mf-chrome-support.component';
import { MfxMessageComponent } from './components/mfx-message/mfx-message.component';
import { MFCustomInputPopupComponent } from '../../framework/components/mf-form-control/mfcustom-input-popup/mfcustom-input-popup.component';
import { MfPopupPanelComponentV2 } from '../../framework/components/mf-popup-panel-v2/mf-popup-panel-v2.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { EmailLookupComponent } from './components/email-lookup/email-lookup.component';
import { ReportBuilderExecutorElementComponent } from './components/report-builder-executor/report-builder-executor-element/report-builder-executor-element.component';
import { LookupValueImportComponent } from './components/lookup-value-import/lookup-value-import.component';
import { MfPrintPdfs } from '../../framework/components/mf-print-pdfs/mf-print-pdfs.component';

@NgModule({
  imports: [
    ComboBoxModule, DateInputsModule, NumericTextBoxModule,
    StorageServiceModule,
    FormsModule,
    CommonModule,
    DropdownModule, SplitterModule,
    TableModule,
    ProgressSpinnerModule,
    CardModule,
    ButtonModule,
    CalendarModule,
    InputTextModule,
    RadioButtonModule,
    MultiSelectModule,
    TriStateCheckboxModule,
    SliderModule,
    AutoCompleteModule,
    InputSwitchModule,
    InputMaskModule,
    InputTextareaModule,
    SpinnerModule,
    ReactiveFormsModule,
    TooltipModule,
    TabViewModule,
    ListboxModule,
    RbLetterAvatarModule,
    FontAwesomeModule,
    PanelModule,
    ToggleButtonModule, ButtonModule,
    DialogModule,
    AccordionModule,
    //PopoverModule,
    AngularSplitModule.forRoot(),
    KeyFilterModule,
    FileUploadModule,
    GalleriaModule,
    //ModalGalleryModule.forRoot(),
    CheckboxModule,
    BreadcrumbModule,
    CardModule,
    PaginatorModule, MatBottomSheetModule,
    ProgressBarModule, ConfirmDialogModule,
    SplitButtonModule,
    FileSaverModule, DynamicDialogModule, GridModule, ScrollViewModule,
    ComboBoxModule, DateInputsModule, NumericTextBoxModule,
    StorageServiceModule,
    FormsModule,
    CommonModule,
    SplitterModule,
    RadioButtonModule,
    MultiSelectModule,
    SliderModule,
    InputMaskModule,
    ReactiveFormsModule,
    ListboxModule,
    PanelModule,
    ToggleButtonModule,
    DialogModule,
    AngularSplitModule.forRoot(),
    KeyFilterModule,
    FileUploadModule,
    ConfirmDialogModule,
    FileSaverModule, DynamicDialogModule, GridModule, ScrollViewModule, WindowModule,
    AutoCompleteModule, TooltipModule,
    MatCheckboxModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatCardModule,
    MatMenuModule,
    MatInputModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatTabsModule,
    MatSidenavModule,
    MatTooltipModule,
    MatChipsModule, MatProgressBarModule,
    MatRippleModule,
    MatRadioModule,
    MatGridListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSliderModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatBadgeModule,

    NbLayoutModule,
    //NbThemeModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbToastrModule.forRoot(),
    NbActionsModule,
    NbAlertModule,
    NbAccordionModule,
    NbStepperModule,
    NbListModule,
    NbCardModule,
    NbSpinnerModule,

    /** Covalent Modules */
    CovalentCommonModule,
    CovalentLayoutModule,
    CovalentMediaModule,
    CovalentExpansionPanelModule,
    CovalentStepsModule,
    CovalentDialogsModule,
    CovalentSearchModule,
    CovalentPagingModule,
    CovalentNotificationsModule,
    CovalentMenuModule,
    CovalentDataTableModule,
    CovalentMessageModule,
    CovalentBreadcrumbsModule,
    CovalentLoadingModule, CovalentTabSelectModule,
    NgxMaskModule.forRoot(),
    SchedulerModule, MatMomentDateModule, MatNativeDateModule,
    NgxMatSelectSearchModule,
    TreeViewModule, ChartsModule, AngularResizedEventModule, TreeListModule, DragDropModule, LayoutModule, UploadsModule,  ExcelModule
  ],
  providers: [],
  declarations: [
    ReportBuilderExecutorComponent,
    PageNotFoundComponent,
    MfFiltersComponent,
    NotAuthorizedComponent,
    GroupByPipe,
    ArraySortPipe,
    LazyLoadedTableComponent,
    MfColumnSelectorComponent,
    MfFormFieldsComponent,
    ListPageComponent,
    MfFormControlComponent,
    MfBladeFormsComponent,
    MfGeneratedFormComponent, MfFiltersComponent, ActionDialogComponent, MfTableV2Component, DropDownListFilterComponent, DateRangeFilterCellComponent,
    PageNotFoundComponent,
    MfFiltersComponent,
    NotAuthorizedComponent,
    GroupByPipe,
    ArraySortPipe,
    MfColumnSelectorComponent,
    MfFormFieldsComponent,
    ListPageComponent,
    MfFormControlComponent,
    MfBladeFormsComponent,
    MfPanelFormsComponent,
    MfPanelComponent,
    MfBreadcrumbsComponent,
    MfGeneratedFormComponent, MfFiltersComponent, ActionDialogComponent, MfTableV2Component, DropDownListFilterComponent, DateRangeFilterCellComponent, IntRangeFilterComponent, FormControlCell,
    MfFormControlComponent, MfControlPopupComponent, MfControlUnsavedPopupComponent, MfPopupPanelComponent, MfPopupPanelComponentV2,
    MFCustomDatePickerComponent, MFCustomTimePickerComponent, MfCustomSignatureComponent,
    PasswordExpiredComponent, MFCustomDatetimePopupComponent, MfBladeComponent, MetricListComponent, MetricComponent, IsEllipsisActiveDirective, DonutWithCenteredTextComponent, AutoPanelNavComponent, MfMultiInstanceGridComponent,
    GridColsDirective, NotificationsComponent, MfMasterDetailGridComponent, FileUploaderComponent, MfChromeSupportComponent, MfcustomUploadComponent, MfxMessageComponent, MFCustomInputPopupComponent, EmailLookupComponent, ReportBuilderExecutorElementComponent,
    LookupValueImportComponent, MfPrintPdfs
  ],
  exports: [ComboBoxModule, DateInputsModule, NumericTextBoxModule, SplitterModule, MfMasterDetailGridComponent, FileUploaderComponent, MfChromeSupportComponent, ReportBuilderExecutorComponent, EmailLookupComponent, ReportBuilderExecutorElementComponent,
    StorageServiceModule,
    FormsModule, ProgressBarModule, TableModule, MfFiltersComponent,
    MfGeneratedFormComponent,
    ProgressSpinnerModule,
    CardModule,
    ButtonModule,
    DropdownModule,
    CalendarModule, MatBottomSheetModule,
    InputTextModule,
    RadioButtonModule,
    MultiSelectModule,
    TriStateCheckboxModule,
    CheckboxModule,
    SliderModule,
    AutoCompleteModule,
    InputSwitchModule,
    InputMaskModule,
    InputTextareaModule,
    SpinnerModule,
    TooltipModule,
    TabViewModule,
    ListboxModule,
    RbLetterAvatarModule,
    FontAwesomeModule,
    PanelModule,
    LazyLoadedTableComponent,
    ToggleButtonModule,
    DialogModule,
    MfColumnSelectorComponent,
    AccordionModule,
    //PopoverModule,
    AngularSplitModule,
    NgxMaskModule,
    KeyFilterModule,
    FileUploadModule,
    GalleriaModule,
    //ModalGalleryModule,
    MfFormFieldsComponent,
    ListPageComponent,
    MfFormControlComponent,
    BreadcrumbModule,
    CardModule,
    PaginatorModule, AutoPanelNavComponent,
    ConfirmDialogModule,
    SplitButtonModule,
    FileSaverModule, DynamicDialogModule, GridModule, MfTableV2Component, ScrollViewModule, DropDownListFilterComponent, DateRangeFilterCellComponent,
    ComboBoxModule, DateInputsModule, NumericTextBoxModule, SplitterModule,
    StorageServiceModule,
    FormsModule, MfFiltersComponent,
    MfGeneratedFormComponent, AutoCompleteModule,
    RadioButtonModule,
    MultiSelectModule,
    SliderModule,
    InputMaskModule,
    ListboxModule,
    PanelModule,
    ToggleButtonModule,
    DialogModule,
    MfColumnSelectorComponent,
    AngularSplitModule,
    KeyFilterModule,
    FileUploadModule,
    //ModalGalleryModule,
    MfFormFieldsComponent,
    ListPageComponent,
    MfFormControlComponent,
    ConfirmDialogModule,
    MfBreadcrumbsComponent,
    FileSaverModule, DynamicDialogModule, GridModule, MfTableV2Component, ScrollViewModule, DropDownListFilterComponent, DateRangeFilterCellComponent, IntRangeFilterComponent, WindowModule, FormControlCell,
    TooltipModule,
    MatCheckboxModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatCardModule,
    MatMenuModule,
    MatInputModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatTabsModule,
    MatSidenavModule,
    MatTooltipModule,
    MatChipsModule, MatProgressBarModule,
    MatRippleModule,
    MatRadioModule,
    MatGridListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSliderModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatBadgeModule, 
    NbLayoutModule,
    NbDatepickerModule,
    NbToastrModule,
    NbActionsModule,
    NbAlertModule,
    NbAccordionModule,
    NbStepperModule,
    NbListModule,
    NbCardModule,
    NbSpinnerModule,

    /** Covalent Modules */
    CovalentCommonModule,
    CovalentLayoutModule,
    CovalentMediaModule,
    CovalentExpansionPanelModule,
    CovalentStepsModule,
    CovalentDialogsModule,
    CovalentLoadingModule,
    CovalentSearchModule,
    CovalentPagingModule,
    CovalentNotificationsModule,
    CovalentMenuModule,
    CovalentDataTableModule,
    CovalentMessageModule,
    CovalentBreadcrumbsModule, CovalentTabSelectModule,
    SchedulerModule, MatMomentDateModule,
    NgxMatSelectSearchModule, TreeViewModule, IsEllipsisActiveDirective, DonutWithCenteredTextComponent, ChartsModule, AngularResizedEventModule, MfMultiInstanceGridComponent, TreeListModule, DragDropModule, LayoutModule,
    GridColsDirective, NotificationsComponent, MfcustomUploadComponent, UploadsModule, MfxMessageComponent, LookupValueImportComponent, MfPrintPdfs, ExcelModule
  ]
})
export class SharedModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fal);
  }
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      providers: [AuthGuard, AuthRoleGuard, SignalRService, ConfirmationService, DialogService, DynamicDialogRef, DynamicDialogConfig, MatDialog,
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }],

      ngModule: SharedModule
    };
  }
}
